import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAddresses } from '../store/addressSlice';

const AddressList = ({ onRowClick }) => {
    const dispatch = useDispatch();
    const { addresses, isLoading } = useSelector((state) => state.address);
    const [searchTerm, setSearchTerm] = useState('');
    const [filtered, setFiltered] = useState([]);
  
    useEffect(() => {
      dispatch(fetchAddresses());
    }, [dispatch]);
  
    useEffect(() => {
      const term = searchTerm.toLowerCase();
      const result = addresses.filter((addr) =>
        Object.values(addr).some((val) =>
          String(val).toLowerCase().includes(term)
        )
      );
      setFiltered(result);
    }, [searchTerm, addresses]);
  
    return (
      <div className="mt-10">
        <h3 className="text-xl font-semibold mb-4">All Addresses</h3>
  
        <input
          type="text"
          placeholder="Search addresses..."
          className="w-full mb-4 px-4 py-2 border rounded shadow-sm focus:ring-2 focus:ring-blue-500"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
  
        {isLoading ? (
          <p className="text-gray-500">Loading addresses...</p>
        ) : (
          <div className="overflow-auto rounded shadow border">
            <table className="min-w-full text-sm text-left text-gray-700">
              <thead className="bg-gray-100 text-xs uppercase text-gray-600">
                <tr>
                  <th className="px-4 py-2">Address Line 1</th>
                  <th className="px-4 py-2">City</th>
                  <th className="px-4 py-2">State</th>
                  <th className="px-4 py-2">Pincode</th>
                  <th className="px-4 py-2">Landmark</th>
                </tr>
              </thead>
              <tbody>
                {filtered.length === 0 ? (
                  <tr>
                    <td colSpan="5" className="px-4 py-3 text-center text-gray-500">
                      No addresses found.
                    </td>
                  </tr>
                ) : (
                  filtered.map((address) => (
                    <tr
                      key={address.id}
                      onClick={() => onRowClick(address)}
                      className="border-t hover:bg-blue-50 cursor-pointer"
                    >
                      <td className="px-4 py-2">{address.addressline1}</td>
                      <td className="px-4 py-2">{address.city}</td>
                      <td className="px-4 py-2">{address.state}</td>
                      <td className="px-4 py-2">{address.pincode}</td>
                      <td className="px-4 py-2">{address.landmark}</td>
                    </tr>
                    
                  ))
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>
    );
  };
  
  export default AddressList;